<template>
  <div>
    <!-- 登录中 -->
    <div class="logining" v-if="queryCode">登录中···</div>
    <div class="loginForm" v-else>
      <div class="head"></div>
      <van-form @submit="handleSubmit">
        <!-- <div class="tab-title">账号登录</div> -->
        <van-field v-model="form.userName" label="用户名" placeholder="请输入用户名"
          :rules="[{ required: true, message: '' }]" />
        <van-field v-model="form.password" type="password" label="密码" placeholder="请输入密码"
          :rules="[{ required: true, message: '' }]" />
        <van-field v-model="form.verifyCode" center clearable label="验证码" placeholder="请输入验证码"
          :rules="[{ required: true, message: '' }]">
          <template #button>
            <img :src="verifyCodeImage" @click="handleGetVerifyCode" />
          </template>
        </van-field>
        <div style="margin: 80px 26px 26px;">
          <van-button round block type="info" native-type="handleSubmit">登录</van-button>
        </div>
      </van-form>


      <!-- <van-loading color="#0094ff" v-if="queryCode">登录中...</van-loading> -->
      <!-- <view class="foot" @click="handleAgreement">登录即代表同意<text>《用户协议》</text></view> -->
    </div>

  </div>
</template>
<script>
import { cacheStorage } from '@/utils'
export default {
  components: {
  },
  data () {
    return {
      form: {
        clientType: 1,
        password: '',
        userName: '',
        verifyCode: ''
      },
      verifyCodeImage: '',
      queryCode: ''
    }
  },
  created () {
    let userInfo = cacheStorage.getItem('user')
    if (userInfo) {
      localStorage.setItem('theCpType', this.$store.state.auth.cpType)
      this.handleRedirectSessionListView()
      } else {
        this.handleGetVerifyCode()
      }
  },
  methods: {
    /**
   * 获取图形验证码
   */
    handleGetVerifyCode () {
      this.$http.get('/scrm/p/chart/verifyCode', {
        params: {
          width: 75,
          height: 35,
          lineSize: 10
        }
      }).then(res => {
        if (res.code === 1) {
          this.verifyCodeImage = res.data
          this.form.verifyCodeSession = sessionStorage.getItem('verifycodesession')
        }
      })
    },
    handleSubmit () {
      this.$http.post('/scrm/v1/user-info/p/userNameLogin', this.form).then(res => {
        if (res.code === 1) {
          this.$store.dispatch('setUser', res.data)
          // 获取租户ID, 五菱项目是单租户的
          // this.$store.dispatch('setTenancyId', 1000)
          this.$router.push('/adminList')
          // this.$toast('登录成功')
          // this.handleRedirectSessionListView()
          // this.handleGetMerchant()
        } else {
          this.$toast(`${res.msg}`)
        }
      })
    },
    // 跳转到相应列表页
    handleRedirectSessionListView () {
      if (this.$store.state.auth.cpType == 4) {
        // 内容库
        this.$router.push('/chatContentPage')
      } else if (this.$store.state.auth.cpType == 11) {
        // 话术库
        this.$router.push('/staffContentPage')
      } else if (this.$store.state.auth.cpType == 12) {
        // 聊天提醒
        this.$router.push('/chatRemind')
      } else if (this.$store.state.auth.cpType == -1) {
        // 会话列表页
        this.$router.push('/sessionList')
      } else if (this.$store.state.auth.cpType === 13) {
        // 智能派单
        this.$router.push('/samrtSendOrder')
      }
    },
    /* handleGetMerchant () {
       this.$http.get(`/scrm/v1/user-info/o/adminList`).then((response) => {
         const { code, data } = response
         if (code === 1 && data && data.length) {
           this.$store.dispatch('setTenancyId', data[0].id)
         }
       })
     },*/
  },
}
</script>

<style lang="less" scoped>
.loginForm {
  height: 100vh;
  background: #f5f5f5;
}
.logining {
  height: 100vh;
  background: #3974c4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 26px;
}
.head {
  background: #3974c4;
  height: 180px;
}
.van-form {
  position: relative;
  top: -12px;
  width: 100%;
  background: #ffffff;
  border-radius: 18px 18px 0 0;
  padding: 20px 0;
}
.tab-title {
  padding: 0 0 20px 25px;
  font-size: 20px;
  color: #007fff;
}

.auth {
  position: relative;
  top: -160px;
  display: flex;
  justify-content: flex-end;
  margin: 0 0 10px 0;
  /deep/ .van-button--plain.van-button--primary {
    color: #007fff;
    border: 0;
  }
}
</style>
